import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@babackapp/ui/components/collapsible";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { ChevronDown } from "lucide-react";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";

type ErrorActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function ErrorActivity({ activity }: ErrorActivityProps) {
  const t = useTranslation();

  const title = {
    "not-enough-stock": t("misc.error"),
    "error-refund-exchange": t("misc.error"),
    carrier: t("errors.shippingError"),
    internal: t("errors.internal"),
    "already-processed-in-shopify": t("errors.alreadyProcessedInShopify"),
    "exchange-complement-payment-missing-at-creation": t(
      "errors.exchangeComplementPaymentMissing",
    ),
  }[activity.errorType as keyof typeof activity.errorType];

  const descriptions = {
    "not-enough-stock": t("errors.notEnoughStock"),
    "error-refund-exchange": t("errors.errorRefundExchange"),
    // @ts-expect-error Not in type definition yet
    carrier: activity.errorDetails,
    // @ts-expect-error Not in type definition yet
    internal: activity.errorDetails,
  };

  const description =
    descriptions[activity.errorType as keyof typeof activity.errorType] ??
    descriptions[activity.errorDetail as keyof typeof activity.errorType] ??
    activity?.params?.errorMessage ??
    activity.errorDetail;

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <ExclamationTriangleIcon className="size-4 text-destructive" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <Collapsible>
          <CollapsibleTrigger asChild>
            <div className="flex gap-1 items-center">
              <ActivityItemHeader
                title={`Error: ${title}`}
                timestamp={activity.date}
              />
              {description && <ChevronDown className="size-4" />}
            </div>
          </CollapsibleTrigger>
          {description && (
            <CollapsibleContent>
              <p className="text-xs font-medium mt-2">{description}</p>
            </CollapsibleContent>
          )}
        </Collapsible>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
